export enum UserTypes {
  PA = 'Patient',
  PH = 'Physician'
}
